export const newsletterTemplates = [
	// Add your 6 templates here
	// Each template should have this structure:
	// {
	// 	title: "Template Title",
	// 	description: "Short description of what this template does",
	// 	prompt: "The prompt text with {{variable_id}} placeholders",
	// 	variables: [
	// 		{
	// 			id: "variable_id",
	// 			name: "Display Name",
	// 			type: "string" | "number" | "date" | "time" | "datetime" | "link",
	// 			placeholder: "Example placeholder text",
	// 			min: 0, // For number type only
	// 			max: 100, // For number type only
	// 			symbol: "%" // For number type only
	// 		}
	// 	]
	// }
	{
		title: "Promozione Evento Speciale",
		description: "Invita i tuoi clienti a un evento speciale presso il tuo locale.",
		prompt: 'Crea un\'email promozionale con immagine iniziale per annunciare una serata speciale/evento: {{event_name}}, {{event_description}}. \n\n' +
			'Data {{event_date}} con inizio alle {{event_start_time}}. \n' +
			'Tono amichevole, energico e un po\' FOMO ma non aggressivo. \n\n' +
			'Descrivi in 2–3 frasi la serata e l\'atmosfera. Consiglia la prenotazione.',
		variables: [
			{
				id: "event_name",
				name: "Nome Evento",
				type: "string",
				placeholder: "es. Serata Jazz Live"
			},
			{
				id: "event_description",
				name: "Descrizione Evento",
				type: "string",
				placeholder: "es. Una serata di musica jazz dal vivo con aperitivo"
			},
			{
				id: "event_date",
				name: "Data Evento",
				type: "date"
			},
			{
				id: "event_start_time",
				name: "Ora Inizio Evento",
				type: "time"
			}
		]
	},
	{
		title: "Cambio di Menù",
		description: "Informa i clienti del cambio di menù con piatti nuovi da provare.",
		prompt: 'Crea un\'email promozionale con immagine iniziale per annunciare il nuovo menù "{{menu_name}}", disponibile da {{start_date}} per {{occasion_name}}.\n\n' +
			'Usa un tono amichevole, caldo ed energico, inserendo una chiara call to action "Scopri il nuovo menù".\n' +
			'Descrivi in 2–3 frasi i piatti e gli ingredienti di stagione utilizzati nel menù. \n' +
			'Mostra un carosello senza le preview di immagini dei prodotti presenti nel menù (max. 4).\n\n' +
			'Sottolinea la stagionalità degli ingredienti e consiglia la prenotazione del tavolo, chiudendo con una CTA "Prenota un tavolo".',
		variables: [
			{
				id: "menu_name",
				name: "Nome Menù",
				type: "string",
				placeholder: "es. Menù Primavera"
			},
			{
				id: "start_date",
				name: "Data Inizio",
				type: "date"
			},
			{
				id: "occasion_name",
				name: "Nome Occorrenza",
				type: "string",
				placeholder: "es. la stagione primaverile"
			}
		]
	},
	{
		title: "Lancio Nuovo Prodotto",
		description: "Annuncia l\'arrivo di un nuovo prodotto con uno sconto dedicato.",
		prompt: 'Crea un\'email promozionale con immagine iniziale per annunciare il nuovo prodotto "{{product_name}}" in arrivo da {{start_date}}.\n\n' +
			'Metti al centro della comunicazione lo sconto del {{discount_percentage}}%, presentandolo come elemento principale dell\'email (in evidenza, subito dopo l\'introduzione).\n' +
			'Lo sconto può essere ritirato mostrando l\'email allo staff.\n\n' +
			'Usa un tono amichevole, caldo ed energico, inserendo una chiara call to action "Scopri i nuovi prodotti". \n\n' +
			'Chiudi con una CTA finale ben visibile: "Acquista ora".',
		variables: [
			{
				id: "product_name",
				name: "Nome Prodotto",
				type: "string",
				placeholder: "es. Birra Artigianale IPA"
			},
			{
				id: "start_date",
				name: "Data Inizio",
				type: "date"
			},
			{
				id: "discount_percentage",
				name: "Percentuale Sconto",
				type: "number",
				placeholder: "es. 15",
				min: 0,
				max: 100,
				symbol: "%"
			}
		]
	},
	{
		title: "Lascia una Recensione",
		description: "Chiedi un\'opinione ai clienti per migliorare il servizio e aumentare le recensioni.",
		prompt: 'Crea un\'email con immagine iniziale e pattern background che esprima felicità per chiedere un feedback sul nostro locale.\n\n' +
			'Posiziona in centro appena sopra al titolo le classiche icone delle stelle per le recensioni.\n' +
			'Sezione (atmosfera, servizio, accoglienza) con rispettive icone posizionati uno sotto l\'altro, con tono amichevole e di ringraziamento.\n\n' +
			'Inserisci una chiara call to action "Lascia il tuo feedback", il link diretto alle recensioni {{review_link}} e chiudi con una CTA ben visibile: "Lascia una recensione".',
		variables: [
			{
				id: "review_link",
				name: "Link Recensioni",
				type: "link",
				placeholder: "https://www.google.com/maps/..."
			}
		]
	},
	{
		title: "Invito a Tornare",
		description: "Offri uno sconto speciale per incentivare i clienti a tornare nel locale.",
		prompt: 'Crea un\'email promozionale con immagine hero iniziale per invitare gli ospiti a tornare a trovarci. \n\n' +
			'Evidenzia una promozione speciale: sconto {{discount_percentage}}% valido mostrando questa email allo staff. \n\n' +
			'Usa un tono amichevole, caldo ed energico. In 2–3 frasi ricorda l\'atmosfera, l\'accoglienza e l\'esperienza vissuta nel nostro locale, invitando a tornare per trascorrere un altro momento speciale. \n' +
			'Mostra un carosello (senza preview di immagini) con alcuni punti di forza del locale o servizi offerti (max. 4). \n\n' +
			'Suggerisci di prenotare in anticipo, chiudendo con una CTA finale: "Prenota un tavolo".',
		variables: [
			{
				id: "discount_percentage",
				name: "Percentuale Sconto",
				type: "number",
				placeholder: "es. 15",
				min: 0,
				max: 100,
				symbol: "%"
			}
		]
	},
	{
		title: "Promo Prenotazione",
		description: "Invita i clienti a prenotare un tavolo sottolineando l\'esperienza e l\'atmosfera.",
		prompt: 'Crea un\'email promozionale con immagine hero iniziale per invitare gli ospiti a prenotare un tavolo nel nostro locale. \n\n' +
			'Solo per chi prenota nelle prossime 2 settimane, offriamo uno sconto speciale del {{discount_percentage}}% valido mostrando questa email allo staff. \n\n' +
			'Usa un tono amichevole, caldo ed energico, ricordando in 2–3 frasi l\'atmosfera, l\'accoglienza e l\'esperienza vissuta, invitando a tornare per trascorrere un altro momento speciale. \n\n' +
			'Sottolinea l\'importanza di prenotare in anticipo, soprattutto nei giorni e orari di maggiore affluenza. \n' +
			'Chiudi con una CTA finale ben visibile: "Prenota un tavolo".',
		variables: [
			{
				id: "discount_percentage",
				name: "Percentuale Sconto",
				type: "number",
				placeholder: "es. 15",
				min: 0,
				max: 100,
				symbol: "%"
			}
		]
	}
];
